import { APPLICATION_STATUSES } from './enums';
/** Kırılım OKUNMADAN ekranda sayı yazılmaz; sıfırlar yalnız başlangıç değeridir. */
export const EMPTY_APPLICATION_STATUS_COUNTS = Object.freeze(Object.fromEntries(APPLICATION_STATUSES.map((status) => [status, 0])));
//# sourceMappingURL=application-counts.js.map